module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-07-4c5e7bb4e9a1d7ab9d561f67f3a1bc18.jpg";